import Vue from 'vue'
import LoginView from './login.vue'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { LoginView },
  template: '<LoginView :googleAppURL="googleAppURL" :csrfToken="csrfToken" :errors="errors"/>',
  data () {
    var configTag = document.querySelector('django-config')
    var errors = document.querySelectorAll('meta.error')
    let errorMessages = []
    for (let item of errors) {
      errorMessages.push(item.getAttribute('contents'))
    }
    console.log(errorMessages)
    let googleAppURL = configTag.getAttribute('google-app-url')
    let csrfToken = configTag.getAttribute('csrf_token')
    return {
      googleAppURL,
      csrfToken,
      errors: errorMessages
    }
  }
})



// WEBPACK FOOTER //
// ./src/login.js